import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageInfo: {
    active: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    set(_, action) {
      return action.payload;
    },
    update(state, action) {
      return { ...state, ...action.payload };
    },
    reset() {
      return initialState;
    },
    setPageInfo(state, action) {
      return {
        ...state,
        pageInfo: { ...state.pageInfo, ...action.payload },
      };
    },
    resetPageInfo() {
      return initialState;
    },
  },
});

export const ui = uiSlice.actions;
export default uiSlice.reducer;
